var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('img',{key:_vm.currentSrc,class:_vm.className,attrs:{"src":_vm.currentSrc,"alt":_vm.alt}})])}
var staticRenderFns = []

export { render, staticRenderFns }